import { render } from "./mbrandDetails.vue?vue&type=template&id=e7261674&scoped=true"
import script from "./mbrandDetails.vue?vue&type=script&lang=js"
export * from "./mbrandDetails.vue?vue&type=script&lang=js"

import "./mbrandDetails.vue?vue&type=style&index=0&id=e7261674&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7261674"]])

export default __exports__